var mock = require('mockjs')
import {http} from '@/config'
import { appConfig } from '@/config.js'
// let sysVarUrl =http.axiosOption.lowcodeURL+'rest/sys/v2/getSysConfig';
let sysVarUrl =http.axiosOption.baseURL+'/rest/sys/v2/getSysConfig';
const handleSysVarUrl = (data) => {
    if (data && data.sysConfigUrl) {
        sysVarUrl = data.sysConfigUrl;
    }
}

handleSysVarUrl(appConfig);
//获取当前系统变量
export const getSysConfig = (data) => {
    let configUrl=sysVarUrl;
    if(appConfig.sysConfigUrl&&data){
        configUrl+="/"+data.sysId+".json"
    }
    return {
        url: configUrl,
        method: 'get',
        params: data,
        openMock: false,
        mock: function (params) {
           return {}
        }
    }
}
